import axios from 'axios'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import { CADASTRAR_CONFIGURACAO_PONTO} from '../types'
import { URL } from '../../util/ambienteActions';

export default function cadastrarConfiguracaoPonto (configuracao) {
    const url = `${URL}/configuracao-ponto`;
    return dispatch => axios.post(url, configuracao, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CADASTRAR_CONFIGURACAO_PONTO,
        payload: response
      })
    );
  }